export { default } from './WelcomeMessage';
